var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sign_out",
    transform: "translate(4.938 6.619)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3012",
    "data-name": "Rectangle 3012",
    width: 24,
    height: 24,
    transform: "translate(-4.938 -6.619)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6753",
    "data-name": "Path 6753",
    d: "M-1426.557-693.356a.75.75,0,0,1-.75-.751.75.75,0,0,1,.75-.75h6.274v-9.263h-6.274a.75.75,0,0,1-.75-.75.75.75,0,0,1,.75-.75h7.024a.75.75,0,0,1,.75.75v10.762a.75.75,0,0,1-.75.751Zm-4-2.417-3.163-3.162a.749.749,0,0,1-.219-.55c0-.008,0-.017,0-.026a.75.75,0,0,1,.393-.66l2.989-2.988a.749.749,0,0,1,1.06,0,.748.748,0,0,1,0,1.06l-1.838,1.838h7.33a.75.75,0,0,1,.751.75.75.75,0,0,1-.751.751h-7.418l1.925,1.926a.748.748,0,0,1,0,1.06.745.745,0,0,1-.53.22A.745.745,0,0,1-1430.555-695.774Z",
    transform: "translate(1433.188 704.869)",
    fill: "#171c28"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOut);
export default __webpack_public_path__ + "static/media/icon_sign_out.1d1f4ce5.svg";
export { ForwardRef as ReactComponent };